import InvoiceForm from './component/InvoiceForm';

function App() {
  return (
    <div>
      <InvoiceForm></InvoiceForm>
    </div>
  );
}

export default App;
